import { jsx } from "react/jsx-runtime";
import { clsx } from "clsx";
const infoClassName = {
    normal: 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500',
    disabled: 'dark:tw-text-neutral-dark-600 tw-text-neutral-light-500',
    error: 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500'
};
const Info = ({ info, inputState })=>/*#__PURE__*/ jsx("p", {
        className: clsx('tw-font-body5', infoClassName[inputState]),
        children: info
    });
const components_Info = Info;
export default components_Info;
